import { Menu } from 'antd'
import styled from 'styled-components'

export const StyledAntMenu = styled(Menu)``
